export const CONDITION_OPERATORS = Object.freeze([
  { key: 'truthy', label: 'truthy' },
  { key: 'eq', label: '=' },
  { key: 'is', label: 'is' },
  { key: 'isNot', label: 'is not' },
  { key: 'gte', label: '>=' },
  { key: 'lte', label: '<=' },
  { key: 'gt', label: '>' },
  { key: 'lt', label: '<' },
  { key: 'includes', label: 'includes' },
])

export const LOGIC_CONDITION_TYPES = Object.freeze([
  { key: 'all', label: 'All', children: 'array' },
  { key: 'any', label: 'Any', children: 'array' },
  { key: 'not', label: 'Not', children: 'single' },
])

export const CONDITION_REGISTRY = Object.freeze([
  { key: 'stat', label: 'Stat', valueControl: 'key', optionSource: 'stats', operators: ['gte', 'lte', 'gt', 'lt', 'eq'] },
  { key: 'attribute', label: 'Attribute', valueControl: 'key', optionSource: 'attributes', operators: ['gte', 'lte', 'gt', 'lt', 'eq'] },
  { key: 'skill', label: 'Skill', valueControl: 'key', optionSource: 'skills', operators: ['gte', 'lte', 'gt', 'lt', 'eq'] },
  { key: 'trait', label: 'Trait', valueControl: 'key', optionSource: 'traits', operators: ['truthy'] },
  { key: 'evidence', label: 'Evidence', valueControl: 'key', optionSource: 'clues', operators: ['truthy'] },
  { key: 'evidenceCount', label: 'Evidence count', valueControl: 'operatorValue', operatorStorage: 'colonValue', operators: ['gte', 'lte', 'gt', 'lt', 'eq'], defaultValue: 'gte:1' },
  { key: 'flag', label: 'Flag', valueControl: 'key', optionSource: 'stateRegistry', operators: ['truthy', 'eq', 'is', 'isNot'] },
  { key: 'turn', label: 'Turn', valueControl: 'number', operatorStorage: 'nestedCondition', operators: ['gte', 'lte', 'gt', 'lt', 'eq'], defaultCondition: { turn: { gte: 1 } } },
  { key: 'phase', label: 'Phase', valueControl: 'keyOrList', optionSource: 'phases', operators: ['truthy'] },
  { key: 'location', label: 'Current location', valueControl: 'key', optionSource: 'locations', operators: ['truthy'], aliases: ['currentLocation'] },
  { key: 'visitedLocation', label: 'Visited location', valueControl: 'key', optionSource: 'locations', operators: ['truthy'] },
  { key: 'unlockedLocation', label: 'Unlocked location', valueControl: 'key', optionSource: 'locations', operators: ['truthy'] },
  { key: 'activeSceneNpc', label: 'Active scene NPC', valueControl: 'key', optionSource: 'npcs', operators: ['truthy'] },
  { key: 'questState', label: 'Quest state path', valueControl: 'path', optionSource: 'questStatePaths', operators: ['truthy', 'eq', 'is', 'isNot'] },
  { key: 'sceneEventState', label: 'Scene event state path', valueControl: 'path', optionSource: 'sceneEventStatePaths', operators: ['truthy', 'eq', 'is', 'isNot'] },
  { key: 'objectState', label: 'Object state path', valueControl: 'path', optionSource: 'objectStatePaths', operators: ['truthy', 'eq', 'is', 'isNot'] },
  { key: 'npcState', label: 'NPC state path', valueControl: 'path', optionSource: 'npcStatePaths', operators: ['truthy', 'eq', 'is', 'isNot'] },
  { key: 'inventory', label: 'Inventory item', valueControl: 'key', optionSource: 'inventory', operators: ['truthy'] },
  { key: 'history', label: 'History query', valueControl: 'history', operators: ['truthy'], defaultCondition: { history: { last: 5 } } },
  { key: 'actionIntent', label: 'Action intent', valueControl: 'key', optionSource: 'actionIntents', operators: ['truthy'] },
  { key: 'actionTarget', label: 'Action target', valueControl: 'key', optionSource: 'actionTargets', operators: ['truthy'] },
  { key: 'claim', label: 'Claim', valueControl: 'key', optionSource: 'claims', operators: ['truthy'] },
])

export const CONDITION_TYPE_OPTIONS = Object.freeze([
  ...LOGIC_CONDITION_TYPES,
  ...CONDITION_REGISTRY,
])

export function conditionDefinitionByKey(key) {
  return CONDITION_TYPE_OPTIONS.find(item => item.key === key || item.aliases?.includes(key)) || null
}

function cloneDefaultCondition(value) {
  return JSON.parse(JSON.stringify(value))
}

export function createDefaultCondition(key = CONDITION_REGISTRY[0].key) {
  const definition = conditionDefinitionByKey(key) || CONDITION_REGISTRY[0]
  if (definition.key === 'all') return { all: [] }
  if (definition.key === 'any') return { any: [] }
  if (definition.key === 'not') return { not: createDefaultCondition() }
  if (definition.defaultValue !== undefined) return { [definition.key]: definition.defaultValue }
  if (definition.defaultCondition) return cloneDefaultCondition(definition.defaultCondition)
  return { [definition.key]: '' }
}
